//相対パスを書かないと駄目
import Bg_bubble from "./common/bg_bubble.es6";
import Ui from "./common/ui.es6";
import Service from "./service/service.es6";
import Top from "./top/top.es6";

const ui = new Ui();
const service = new Service();
const top = new Top();

//背景泡
if (!$("body").hasClass("home")) {
  const bg = new Bg_bubble();
}
